import React from 'react'
import { Grid } from "@mui/material";
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { UiInputGroupWr } from "../../../../../../_uiComponents/common/form/UiInputComponents";
import UiInput from '../../../../../../_uiComponents/telerikComponents/UiInput'
import Stack from '@mui/material/Stack';
import {
    UiButton,
} from "../../../../../../_uiComponents/common/form/UiButton";
// import GamePlayRewardPotConfiguration from './GamePlayRewardPotConfiguration';
// import UiTopDropDownList from '../../../../../_uiComponents/telerikComponents/UiTopDropDownList';
// import { UiRadioButton } from '../../../../../_uiComponents/telerikComponents/UiRadioButton';

export default function GameplayWheelConfigurationForm(props) {


    const totalRewardSlotsValidator = value => value ? '' : 'Total Reward Slots is required.';
    const totalUnluckySlotsValidator = value => value ? '' : 'Total Unlucky Slots is required.';


    const handleSubmit = dataItem => {
        // const payload = {
        //     TotalRewardSlots: dataItem.totalRewardSlots
        // }
    }

    return (
        <>

            <UiInputGroupWr
                title="Gameplay Wheel Configuration"
            >
                <Form onSubmit={handleSubmit}
                    render={formRenderProps =>
                        <Grid container spacing={2} sx={{ mb: 1 }}>
                            <Grid
                                item
                                xs={12}
                                lg={6}
                            >
                                <Field name={'totalRewardSlots'}
                                    validator={totalRewardSlotsValidator}
                                    component={UiInput}
                                    labelClassName={'k-form-label'}
                                    label={'Total Reward Slots'} />

                            </Grid>
                            <Grid
                                item
                                xs={12}
                                lg={6}
                            >
                                <Field name={'totalUnluckySlots'}
                                    validator={totalUnluckySlotsValidator}
                                    component={UiInput}
                                    labelClassName={'k-form-label'}
                                    label={'Total Unlucky Slots'} />

                            </Grid>
                            <Grid item xs={12} lg={12} sx={{ mb: 2 }} >
                                <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%' }}>
                                    <UiButton
                                        name="Cancel"
                                        variant="outlined"
                                        size="small"
                                        onClick={formRenderProps.onFormReset}
                                    />
                                    <UiButton
                                        name="Save"
                                        variant="contained"
                                        size="small"
                                        onClick={formRenderProps.onSubmit}
                                        disabled={!formRenderProps.allowSubmit}
                                    />
                                </Stack>
                            </Grid>
                        </Grid>
                    }
                />
            </UiInputGroupWr>


        </>
    )
}
